const PATCH_FLAG = 'data-a11y-patched';

const patchBlazeButtons = () => {
    document.querySelectorAll('.blaze-prev, .blaze-next').forEach((btn) => {
        if (btn.hasAttribute(PATCH_FLAG)) return;
        if (!btn.hasAttribute('aria-label') && !btn.textContent.trim()) {
            btn.setAttribute('aria-label', btn.classList.contains('blaze-prev') ? 'Previous slide' : 'Next slide');
        }
        if (!btn.hasAttribute('type')) btn.setAttribute('type', 'button');
        btn.setAttribute(PATCH_FLAG, '');
    });
};

const cleanAltText = (text) => {
    const normalized = text.replace(/\s+/g, ' ').trim().replace(/[\s:•\-–—]+$/g, '').trim();
    if (!normalized) return '';
    return normalized.length > 120 ? `${normalized.slice(0, 117).trim()}…` : normalized;
};

const altFromContext = (img) => {
    const para = img.closest('p, figure, li, div');
    if (!para) return '';
    let node = para.previousElementSibling;
    let hops = 0;
    while (node && hops < 4) {
        const heading = node.matches('h1, h2, h3, h4, h5, h6') ? node : node.querySelector?.('h1, h2, h3, h4, h5, h6');
        const strong = !heading && node.querySelector?.('strong, b');
        const source = heading || strong;
        if (source) {
            const text = cleanAltText(source.textContent || '');
            if (text) return text;
        }
        if (node.tagName === 'P') {
            const text = cleanAltText(node.textContent || '');
            if (text) return text;
        }
        node = node.previousElementSibling;
        hops += 1;
    }
    return '';
};

const altFromContainer = (img) => {
    const container = img.closest('.tpo_modal-container, .tpo_modal-content, .ql-editor');
    if (!container) return '';
    const heading = container.querySelector('h1, h2, h3, h4, h5, h6, .tpo_modal-heading');
    return heading ? cleanAltText(heading.textContent || '') : '';
};

const altFromPage = () => {
    const h1 = document.querySelector('main h1, .product__title, h1');
    return h1 ? cleanAltText(h1.textContent || '') : '';
};

const looksLikeJunkFilename = (base) => {
    const compact = base.replace(/[_-]/g, '');
    if (/^[0-9a-f]{12,}$/i.test(compact)) return true;
    if (/^image[_-]?[0-9a-f]{8,}/i.test(base)) return true;
    if (/^(img|photo|picture|pasted|screenshot|untitled)[_-]?\d*$/i.test(base)) return true;
    return false;
};

const altFromFilename = (img) => {
    try {
        const url = new URL(img.currentSrc || img.src, document.baseURI);
        const file = url.pathname.split('/').pop() || '';
        const base = file.replace(/\.[a-z0-9]+$/i, '').replace(/[_-]+\d+x\d+$/i, '');
        if (looksLikeJunkFilename(base)) return '';
        return cleanAltText(base.replace(/[_-]+/g, ' '));
    } catch {
        return '';
    }
};

const patchRichTextImages = () => {
    document.querySelectorAll('.tpo_modal-content img, .ql-editor img').forEach((img) => {
        const current = img.getAttribute('alt')?.trim();
        if (current) {
            img.setAttribute(PATCH_FLAG, '');
            return;
        }
        const derived = altFromContext(img) || altFromContainer(img) || altFromFilename(img) || altFromPage() || 'Image';
        img.setAttribute('alt', derived);
        img.setAttribute(PATCH_FLAG, '');
    });
};

const patchHiddenEmptyHeadings = () => {
    document.querySelectorAll('.tpo_modal-heading.tpo_hidden').forEach((container) => {
        const hasNonEmptyContent = Array.from(container.children).some(
            (child) => child.textContent.trim() || child.querySelector('img, svg')
        );
        if (!hasNonEmptyContent) container.remove();
    });
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((h) => {
        if (!h.textContent.trim() && !h.querySelector('img, svg')) h.remove();
    });
};

const patchOrphanedLabels = () => {
    document.querySelectorAll('label[class^="tpo_"], label[class*=" tpo_"]').forEach((label) => {
        if (label.hasAttribute(PATCH_FLAG)) return;
        if (label.hasAttribute('for')) { label.setAttribute(PATCH_FLAG, ''); return; }
        if (label.querySelector('input, select, textarea')) { label.setAttribute(PATCH_FLAG, ''); return; }
        label.setAttribute('role', 'presentation');
        label.setAttribute(PATCH_FLAG, '');
    });
};

const patchCartQtyInputs = () => {
    document.querySelectorAll('input.cart__qty-input').forEach((input) => {
        if (input.hasAttribute(PATCH_FLAG)) return;
        if (!input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
            input.setAttribute('aria-label', 'Quantity');
        }
        input.setAttribute(PATCH_FLAG, '');
    });
};

const patchBoostSdFilterSearch = () => {
    document.querySelectorAll('input.boost-sd__filter-option-search-option').forEach((input) => {
        if (input.hasAttribute(PATCH_FLAG)) return;
        if (!input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
            input.setAttribute('aria-label', input.getAttribute('placeholder')?.trim() || 'Search filter options');
        }
        input.setAttribute(PATCH_FLAG, '');
    });
};

const ensureA11yMessageTargets = () => {
    document.querySelectorAll('[aria-describedby], [aria-labelledby]').forEach((el) => {
        ['aria-describedby', 'aria-labelledby'].forEach((attr) => {
            const value = el.getAttribute(attr);
            if (!value) return;
            value.split(/\s+/).filter(Boolean).forEach((id) => {
                if (document.getElementById(id)) return;
                const p = document.createElement('p');
                p.id = id;
                p.className = 'visually-hidden';
                p.setAttribute('aria-hidden', 'false');
                p.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;color:#000;background:#fff;';
                if (id === 'a11y-refresh-page-message') {
                    p.textContent = 'Choosing a selection results in a full page refresh.';
                } else if (id === 'a11y-new-window-message') {
                    p.textContent = 'Opens in a new window.';
                } else if (id === 'a11y-selection-message') {
                    p.textContent = 'Press the spacebar to confirm your selection.';
                } else {
                    p.textContent = '';
                }
                document.body.appendChild(p);
            });
        });
    });
};

const patchUnlabeledIframes = () => {
    document.querySelectorAll('iframe').forEach((iframe) => {
        if (iframe.hasAttribute(PATCH_FLAG)) return;
        if (iframe.title || iframe.hasAttribute('aria-label') || iframe.hasAttribute('aria-labelledby')) {
            iframe.setAttribute(PATCH_FLAG, '');
            return;
        }
        const id = iframe.id || '';
        if (id === 'PBarNextFrame') iframe.setAttribute('title', 'Pre-order progress');
        else iframe.setAttribute('title', 'Embedded content');
        iframe.setAttribute(PATCH_FLAG, '');
    });
};

const patchTpoListDirectButtons = () => {
    document.querySelectorAll('ul.tpo_cart-properties-wrapper > button, ul.tpo_cart-properties-wrapper > span').forEach((el) => {
        if (el.hasAttribute(PATCH_FLAG)) return;
        const li = document.createElement('li');
        el.replaceWith(li);
        li.appendChild(el);
        el.setAttribute(PATCH_FLAG, '');
    });
};

const scan = () => {
    patchBlazeButtons();
    patchRichTextImages();
    patchHiddenEmptyHeadings();
    patchOrphanedLabels();
    patchCartQtyInputs();
    patchBoostSdFilterSearch();
    patchUnlabeledIframes();
    patchTpoListDirectButtons();
    ensureA11yMessageTargets();
};

const SCAN_DELAYS = [0, 200, 800, 1500, 3000];
const pending = SCAN_DELAYS.map(() => false);

const scheduleScan = () => {
    SCAN_DELAYS.forEach((delay, i) => {
        if (pending[i]) return;
        pending[i] = true;
        const run = () => { pending[i] = false; scan(); };
        if (delay === 0) queueMicrotask(run);
        else setTimeout(run, delay);
    });
};

export default function patchThirdPartyA11y() {
    if (document.readyState === 'complete') {
        scan();
    } else {
        window.addEventListener('load', scan, { once: true });
    }
    const opts = { passive: true, capture: true };
    document.addEventListener('click', scheduleScan, opts);
    document.addEventListener('focusin', scheduleScan, opts);
    document.addEventListener('touchstart', scheduleScan, opts);
}
